import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import SchedulerTable from './components/SchedulerTable'
import {useParams} from 'react-router-dom'
import SchedulerTableFilter from './components/SchedulerTableFilter'

type Props = {
  className: string
}
const SchedulerPage: FC<Props> = (props) => {
  const intl = useIntl()
  const {id} = useParams<{id: string}>()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'SCHEDULER.PAGE_TITLE'})}</PageTitle>
      <div className='card mb-10'>
        <SchedulerTableFilter />
        <div className='card-body p-10'>
          <SchedulerTable userId={id} />
        </div>
      </div>
    </>
  )
}

export default SchedulerPage
